import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=a6f80388&scoped=true&"
import script from "./Column.vue?vue&type=script&lang=js&"
export * from "./Column.vue?vue&type=script&lang=js&"
import style0 from "./Column.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Column.vue?vue&type=style&index=1&id=a6f80388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f80388",
  null
  
)

export default component.exports